import { createSlice } from '@reduxjs/toolkit';
import { analiticDefaultFilter, AnaliticStore } from './types';

const initialState: AnaliticStore = {
  filter: analiticDefaultFilter,
  currentAnaliticAction: null,
};

const analiticSlice = createSlice({
  name: 'analitic',
  initialState,
  reducers: {
    setCurrentAction: (state, { payload }) => {
      state.currentAnaliticAction = payload;
    },
    setAnaliticFilter: (state, { payload }) => {
      state.filter = payload;
    },
  },
});

export const { setCurrentAction, setAnaliticFilter } = analiticSlice.actions;
export default analiticSlice.reducer;
